import { SquareCheckBig } from "lucide-react";
import { Helmet } from "react-helmet";
export default function TaskManagementOrganizeTrack() {
  return (
    <>
      <Helmet>
        <title>Organized. Track. Complete. | Simplifyte</title>
      </Helmet>

      <section className="hero-section">
        {/* Glow Backgrounds */}
        {/* <div className="hero-glow hero-glow-left" /> */}
        {/* <div className="hero-glow hero-glow-right" /> */}

        <div className="hero-container">
          <div className="hero-content">
            {/* Badge */}
            {/* <div className="hero-pill">
              <SquareCheckBig className="hero-pill-icon" />
              <span className="hero-pill-span">Effortless Task Management</span>
            </div> */}

            {/* Title */}
            <h1 className="task-management-hero-title">
              Organize. Track.
              <br />
              <span className="hero-title-gradient">Complete.</span>
            </h1>

            {/* Description */}
            <p className="task-management-hero-desc">
              A clutter-free, intuitive interface built for productivity.
              <br />
              Manage tasks your way with unlimited customization.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
